export default __webpack_public_path__ + "static/care-credit-0a2e335405c9ea49b06b768af1933667.png";